import React, { useContext } from "react";
import { t } from "@lingui/macro";
import { PaymentContext } from "../contexts/PaymentProvider";

export function PaymentError() {
  const { paymentError } = useContext(PaymentContext);

  const tt = useTranslations();
  if (paymentError) {
    return (
      <div
        className="border-2 border-red rounded-xl text-red flex flex-row justify-center items-center p-4 text-lg mt-6"
        style={{ backgroundColor: "rgba(255, 191, 191, 0.2)" }}
      >
        {/* Warning icon */}
        <svg
          width="22"
          height="19"
          viewBox="0 0 22 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-4 flex-shrink-0"
        >
          <path d="M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z" fill="#EB1B1B" />
        </svg>

        {typeof paymentError === "string" ? paymentError : tt.genericPaymentProcessError}
      </div>
    );
  } else {
    return null;
  }
}

function useTranslations() {
  return {
    genericPaymentProcessError: t({
      id: "SignUpFlow.genericPaymentProcessError",
      message:
        "There was an error processing your payment information. Please check that all fields are filled out correctly and try again.",
    }),
  };
}
